import React, { useContext, useEffect } from 'react';
import { ConfirmContext } from 'src/containers/Common';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  hideModal: () => void;
};

export const DonationPageListModalCantArchive: React.FC<Props> = ({ hideModal }: Props) => {
  const confirm = useContext(ConfirmContext);

  const tHelper = useTHelper('donationPageList.modals.cantarchive');

  useEffect(() => {
    confirm(
      {
        body: tHelper('body'),
        header: tHelper('header'),
        successBtnText: tHelper('successBtnText'),
        singleButton: true,
      },
      hideModal
    );
  }, [confirm, hideModal, tHelper]);

  return null;
};
